import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

config({ licenseKey });

if (environment.production) {
    enableProdMode();
}

platformBrowser()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    })

    .catch((err) => console.error(err));